export default __webpack_public_path__ + "images/31464754d39e5cabe7866bfca0a94525.svg";